import { MaintenanceForwardingEstablishmentChoiceEntryProposalStatus } from '../establishmentChoiceEntry.type'
import { MaintenanceDiagnosticEntryProposalContentData } from './diagnosticEntryProposalContent.type'
import { MaintenanceExecutionEntryProposalContentData } from './executionEntryProposalContent.type'

export type MaintenanceForwardingEstablishmentChoiceEntryProposalContentData =
  | MaintenanceDiagnosticEntryProposalContentData
  | MaintenanceExecutionEntryProposalContentData

export const isExecutionEntryProposalContent = (
  content: MaintenanceForwardingEstablishmentChoiceEntryProposalContentData | undefined | null,
  proposalStatus: MaintenanceForwardingEstablishmentChoiceEntryProposalStatus | undefined | null,
): content is MaintenanceExecutionEntryProposalContentData => {
  if (!content) return false
  return 'piece_modifications' in content && proposalStatus !== MaintenanceForwardingEstablishmentChoiceEntryProposalStatus.Completed;
}
